import { useSelector } from 'react-redux';
import { RootState } from 'redux/root';
import Package from 'static/models/Package';

export const useAvailablePackages = (): Package[] => {
    return useSelector((state: RootState) => state.availablePackages);
};
